import { render, staticRenderFns } from "./Shape.vue?vue&type=template&id=0b92ce00&scoped=true&"
import script from "./Shape.vue?vue&type=script&lang=js&"
export * from "./Shape.vue?vue&type=script&lang=js&"
import style0 from "./Shape.vue?vue&type=style&index=0&id=0b92ce00&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92ce00",
  null
  
)

export default component.exports